export default "Lav jeres egne simple panfløjter af sugerør og spil magisk musik!";